import { createLogger } from '@eventstore-ui/utils';

export const logger = createLogger(
    '@eventstore-ui/layout',
    'linear-gradient(15deg, #13547a 0%, #80d0c7 100%)',
);
